module.exports = __webpack_public_path__ + "media/KZ-VOS.d7ffd5de.ogg";